import { createHmac } from "crypto";

export async function _computeHMAC(data: any, key: any) {
  const result = createHmac("sha256", key).update(data).digest("hex");
  return result;
}
